// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3eAuk","head":"ProcedureTableInfo_head__2K0P9"};